module.exports = __webpack_public_path__ + "static/media/04-submenu.06c02933.png";